// extracted by mini-css-extract-plugin
module.exports = {"container":"filePreviewFormProjectPage_container__3gmzl","title":"filePreviewFormProjectPage_title__2JIAF","delete":"filePreviewFormProjectPage_delete__115tN","deleteIcon":"filePreviewFormProjectPage_deleteIcon__1VVnO"};
    if(module.hot) {
      // 1790670497814
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  